export default __webpack_public_path__ + "static/media/default_header.06a3815c.png";